<template>
  <v-container >
    <div class="default-theme">
      <v-img
        :src="require('../assets/contact_us_banner.jpg')"
        width= "100%"
        height= "47%"
        class="shop-image"
      />
      <div class="showfromtop" data-aos="showeffect" data-aos-duration="3000"></div>
    </div>
    <v-row v-if="!$vuetify.breakpoint.xs" >
      <v-col md="8" lg="8" class="pa-10 default-theme">
        <div class="info-container">
          <div :class="[$i18n.locale=='en'?'company-name georgia font-size-XXL':'company-name NotoSerifTC font-size-XXL']">{{$t('contact_page.company_name')}}</div>
          <v-row>
            <v-col lg="8" md="8"> 
              <div :class="$i18n.locale=='en'?'info-title georgia font-size-XL':' info-title NotoSerifTC font-size-XL'">{{$t('contact_page.address_title')}}</div>
              <div v-if="$i18n.locale=='en'" class="info-detail font-size-s7"> Flat B, C & D1, 6th Floor, China Insurance Group Building, </div>
              <div v-if="$i18n.locale=='en'" class="info-detail font-size-s7"> 141 Des Voeux Road Central, Central, Hong Kong</div>
              <div v-if="$i18n.locale!=='en'" class="info-detail font-size-s7">香港中環德輔道中 141 號中保集團大廈 6樓 B、C 及 D1 室</div>
            </v-col>
          </v-row>
          <v-row>  
            <v-col sm="6" lg="4" md="4">
              <div :class="$i18n.locale=='en'?'info-title georgia font-size-XL':' info-title NotoSerifTC font-size-XL'">{{$t('contact_page.tel_title')}}</div>
              <div class="info-detail font-size-s7">(852) 2557 6123</div>
            </v-col>
            <v-col sm="6" lg="4" md="4">
              <div :class="$i18n.locale=='en'?'info-title georgia font-size-XL':' info-title NotoSerifTC font-size-XL'">{{$t('contact_page.fax_title')}}</div>
              <div class="info-detail font-size-s7">(852) 2557 5621</div>
            </v-col>
            <v-col sm="6" lg="6" md="6">
              <div :class="$i18n.locale=='en'?'info-title georgia font-size-XL':' info-title NotoSerifTC font-size-XL'">{{$t('contact_page.email_title')}}</div>
              <div class="info-detail font-size-s7 email"><a class="mailto" :href="'mailto:info@lorencegroup.com'">info@lorencegroup.com</a></div>
            </v-col>
          </v-row>
          <div class="showfromtop" data-aos="showeffect" data-aos-duration="3000"></div>
        </div>
        <div style="position:relative;padding-top:42%;display:flex;width:75%;margin-top:50px;" data-aos="fade-up" data-aos-duration="3000">
          <GmapMap
            :center="{lat:22.285758783439938, lng:114.15522879824249}"
            :zoom="17"
            map-type-id="roadmap"
            style="z-index:5;position:absolute;height:100%;width:100%;top:0;left:0;"
            :options="mapStyle"
          >
            <GmapMarker
              :position="{lat:22.285758783439938, lng:114.15522879824249}"
            />
          </GmapMap>
        </div>
      </v-col>
      <v-col md="4" lg="4" class="pa-3">
        <div class="form-container" style="margin-top:40px;" data-aos="fade-up" data-aos-duration="3000">
          <div :class="$i18n.locale=='en'?'georgia font-size-XXL':'NotoSerifTC font-size-XXL'" class="form-title">{{$t('contact_page.contact_us')}}</div>
          <div :class="$i18n.locale=='en'?'DinCondL font-size-s7':'MHeiHK '" class="info-detail  info-detail-size">
          <label for="fname">{{$t('contact_page.form_name')}}</label>
          <input type="text" id="fname" name="fname" v-model="form.name">
          <label for="fname">{{$t('contact_page.form_email')}}</label>
          <input type="text" id="fname" name="fname" v-model="form.email">
          <label for="fname">{{$t('contact_page.form_subject')}}</label>
          <input type="text" id="fname" name="fname" v-model="form.subject">
          <label for="fname">{{$t('contact_page.form_message')}}</label>
          <textarea rows="4" cols="50"  v-model="form.message">
          </textarea>
          </div>
          <div :class="submitted?'submit-btn-submitted':''" class="submit-btn d-flex align-center justify-center" v-on:click="submitForm">{{$t('contact_page.form_submit_button')}}</div>
          <span v-if="submitted" style="color:#1d953b;margin-top:10px;cursor: default;">{{$t('contact_page.form_submit_message')}}</span>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="$vuetify.breakpoint.xs" >
      <div class="pa-10 default-theme">
          <div :class="[$i18n.locale=='en'?'company-name georgia font-size-XXL':'company-name NotoSerifTC font-size-XXL']">{{$t('contact_page.company_name')}}</div>
            <div style="float:left;margin-top: 30px;">
              <div :class="$i18n.locale=='en'?'info-title georgia font-size-XL':' info-title NotoSerifTC font-size-XL'">{{$t('contact_page.address_title')}}</div>
              <div v-if="$i18n.locale=='en'" class="info-detail info-detail-size">Flat B, C & D1, 6th Floor, China Insurance Group Building, </div>
              <div v-if="$i18n.locale=='en'" class="info-detail info-detail-size">141 Des Voeux Road Central, Central, Hong Kong</div>
              <div v-if="$i18n.locale!=='en'" class="info-detail info-detail-size">香港中環德輔道中 141 號中保集團大廈 6樓 B、C 及 D1 室</div>
            </div>  
            <div style="float:left;margin-top: 15px;">
              <div :class="$i18n.locale=='en'?'info-title georgia font-size-XL':' info-title NotoSerifTC font-size-XL'">{{$t('contact_page.tel_title')}}</div>
              <div class="info-detail info-detail-size">(852) 2557 6123</div>
            </div>
            <div style="float:left;margin-left: 35px;margin-top: 15px">
              <div :class="$i18n.locale=='en'?'info-title georgia font-size-XL':' info-title NotoSerifTC font-size-XL'">{{$t('contact_page.fax_title')}}</div>
              <div class="info-detail info-detail-size">(852) 2557 5621</div>
            </div>
            <div style="float:left;margin-bottom: 30px;margin-top: 15px">
              <div :class="$i18n.locale=='en'?'info-title georgia font-size-XL':' info-title NotoSerifTC font-size-XL'">{{$t('contact_page.email_title')}}</div>
              <div class="info-detail info-detail-size email"><a class="mailto" :href="'mailto:info@lorencegroup.com'">info@lorencegroup.com</a></div>
            </div>
        <div class="map-container" data-aos="fade-up" data-aos-duration="3000">
          <GmapMap
            :center="{lat:22.285758783439938, lng:114.15522879824249}"
            :zoom="17"
            map-type-id="roadmap"
            style="z-index:5;position:absolute;height:100%;width:100%;top:0;left:0;"
            :options="mapStyle"
          >
            <GmapMarker
              :position="{lat:22.285758783439938, lng:114.15522879824249}"
            />
          </GmapMap>
        </div>
      </div>
      <div class="pa-10">
        <div class="form-container" style="margin-top:40px;" data-aos="fade-up" data-aos-duration="3000">
          <div :class="$i18n.locale=='en'?'georgia ':'NotoSerifTC'" class="form-title contact-us-fontsize">{{$t('contact_page.contact_us')}}</div>
          <div :class="$i18n.locale=='en'?'DinCondL':'MHeiHK'" class="info-detail  info-detail-size">
          <label for="fname">{{$t('contact_page.form_name')}}</label>
          <input type="text" id="fname" name="fname" v-model="form.name">
          <label for="fname">{{$t('contact_page.form_email')}}</label>
          <input type="text" id="fname" name="fname" v-model="form.email">
          <label for="fname">{{$t('contact_page.form_subject')}}</label>
          <input type="text" id="fname" name="fname" v-model="form.subject">
          <label for="fname">{{$t('contact_page.form_message')}}</label>
          <textarea rows="4" cols="50"  v-model="form.message">
          </textarea>
          </div>
          <div :class="submitted?'submit-btn-submitted':''" class="submit-btn d-flex align-center justify-center" v-on:click="submitForm">{{$t('contact_page.form_submit_button')}}</div>
          <span v-if="submitted" style="color:#1d953b;margin-top:10px;cursor: default;">{{$t('contact_page.form_submit_message')}}</span>
        </div>
      </div>
    </v-row>
  </v-container>
</template>

<script>
  import axios from 'axios';
  var ip = "https://lorencegroup.com/api";
  export default {
    name: 'Contact',
    components: {
    },
    data: () => ({
      submitted: false,
      mapStyle: {
        styles:[{
          stylers: [{
            saturation: -100
          }]
        }]
      },
      form:{
        name: "",
        email: "",
        subject: "",
        message: ""
      }
    }),
    methods: {
      submitForm: function(){
      console.log(this.form)
        axios.post(ip+"/contacts", this.form)
        .then(response => {
          console.log(response)
          this.submitted = true;
        })
        .catch(e => {
          console.log(e)
          //this.errors.push(e)
        })
      }
    }
  }
</script>

<style scoped>
.container{
  padding: 0px;
  height: fit-content;
}
.shop-image-container{
  padding-top: 36.3%;
  position: relative;
}
.info-container{
  width: auto;
}
.form-container{
  border: 1px solid white;
  padding: 7% 10% 10% 10%;
}
.company-name{
  cursor: default;
  width: fit-content;
  text-align: left;
  font-weight: bold;
  letter-spacing: 6px;
  color: #1d953b;
}
.mobile .company-name{
  cursor: default;
  width: fit-content;
  font-weight: bold;
  letter-spacing: 6px;
  color: white;
}
.info-title{
  cursor: default;
  letter-spacing:3px;
  margin-top: 4%;
  width: fit-content;
  color: white;
}
.mobile .info-title{
  font-size: 18px;
}
.info-row{
  font-family: 'DinCondL';
  width: fit-content;
  color: white;
  size: 20px;
  letter-spacing: 3px;
  margin-top: 3px;
}
.map-container{
  position:relative;
  padding-top:42%;
  display:flex;
  width:75%;
  margin-top:50px;
}
.mobile .map-container{
  width:100%;
  height:50%;
  margin-top: 30px;
  margin-bottom: 40px;
}
.info-detail{
  cursor: default;
  text-align: left;
  width: fit-content;
  color: white;
  letter-spacing: 2.5px;
  margin-top: 3px;
}
.mobile .info-detail{
  font-size: 16px;
  float: left;
  text-align: start;
}
.form-title{
  font-weight: bold;
  letter-spacing:6px;
  color: white;
  width: 100%;
  text-align: left;
  cursor: default;
}
.form-container label{
  cursor: default;
  margin-top: 20px;
  letter-spacing:3px;
  color: white;
  float: left;
}
.form-container input{
  background-color: white;
  margin-top: 10px;
  width: 100%;
  height: 40px;
}
.form-container textarea{
  background-color: white;
  margin-top: 10px;
  width: 100%;
  height: 250px;
}
.submit-btn{
  font-family: 'DinCondL';
  font-size:20px;
  letter-spacing:2px;
  margin-top: 10px;
  height: 40px;
  background-color: #1E953C;
  color: white;
  width: 100%;
  cursor: pointer;
}

.submit-btn:hover{
  background-color: black;
}

.submit-btn-submitted{
  background-color: black;
  cursor: default;
}

.info-email{
  font-family: 'DinCondL';
  width: fit-content;
  color: white;
  letter-spacing: 3px;
  margin-top: 3px;
}

.email{
  cursor: pointer;
}

.email:hover{
  color: #1E953C;
}

@media (min-width: 375px){
  .contact-us-fontsize{
    font-size: 20px;
  }
}


@media (min-width: 992px) { 
  .contact-us-fontsize{ 
    font-size:21px;
  }
}

@media (min-width: 1264px) {
  .contact-us-fontsize{ 
    font-size:23px;
  }
}

@media (min-width: 1904px){
  .contact-us-fontsize{
    font-size:28px;
  }
}

@media (min-width: 992px) { 
  .info-title-size{ 
    font-size:16px;
  }
}

@media (min-width: 1264px) {
  .info-title-size{ 
    font-size:18px;
  }
}

@media (min-width: 1904px){
  .info-title-size{
    font-size: 20px;
  }
}

@media (min-width: 992px) { 
  .info-detail-size{ 
    font-size:14px;
  }
}

@media (min-width: 1264px) {
  .info-detail-size{ 
    font-size:16px;
  }
}

@media (min-width: 1904px){
  .info-detail-size{
    font-size: 18px;
  }
}
</style>